<template>
  <div class="event-playlist -mx-6 sm:mx-0">
    <div
      v-if="tracks.length > 0"
      class="search-results"
    >
      <mj-event-playlist-toolbar
        v-if="isDefaultUser"
        :filters="filters"
        :active-filter="activeFilter"
        :tracks="tracks"
        :is-guest-track-syncing-busy="isGuestTrackSyncingBusy"
        @activated="activateFilter"
        @sync-all-guest-tracks="syncAllGuestTracks"
      />
      <mj-track-list
        :tracks="filteredTracks"
        :stored-tracks="tracks"
        @track-selected="sync"
      />
    </div>
    <mj-empty-playlist v-else />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import EmptyPlaylist from '@/components/ui/content-placeholder/EmptyPlaylist.vue';
import EventPlaylistToolbar from '@/components/event/EventPlaylistToolbar.vue';
import TrackList from '@/components/tracks/TrackList.vue';

export default {
  components: {
    'mj-empty-playlist': EmptyPlaylist,
    'mj-event-playlist-toolbar': EventPlaylistToolbar,
    'mj-track-list': TrackList,
  },

  data() {
    return {
      activeFilter: null,
      filters: [
        { label: 'Alle', key: null },
        { label: 'Meine Tracks', key: 'user' },
        { label: 'Gäste Tracks', key: 'subUser' },
      ],
      isGuestTrackSyncingBusy: false,
    };
  },

  computed: {
    ...mapGetters(['currentEvent', 'isDefaultUser']),

    tracks() {
      return this.currentEvent.playlist.tracks;
    },

    notSyncedGuestTracks() {
      return this.tracks.filter(track => !track.is_transferred && track.trackable_type === 'subUser');
    },

    filteredTracks() {
      if (this.activeFilter === null) {
        return this.currentEvent.playlist.tracks;
      }
      return this.currentEvent.playlist.tracks.filter(track => track.trackable_type === this.activeFilter);
    },
  },

  methods: {
    ...mapActions(['toggleTrack', 'synchronizeFromSpotifyPlaylist', 'syncGuestTracks']),

    activateFilter(filter) {
      this.activeFilter = filter.key;
    },

    sync(track) {
      this.toggleTrack(track)
        .then()
        .catch(error => {
          console.error(error);
        });
    },

    syncAllGuestTracks() {
      this.isGuestTrackSyncingBusy = true;
      this.syncGuestTracks(this.notSyncedGuestTracks)
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.isGuestTrackSyncingBusy = false;
        });
    },
  },

  activated() {
    if (this.isDefaultUser) {
      this.synchronizeFromSpotifyPlaylist();
    }
  },

};

</script>
